// @flow
import { useState, useCallback } from 'react';
// import i18n from 'app/i18n'; // TODO internationalisation

// $FlowFixMe
import { add2cart } from 'app/common/actions/shop/cart/add2cart';
// import { updateCartItem } from 'app/common/actions/shop/cart/updateCartItem';
import getNumEnding from 'app/common/lib/getNumEnding';
import { showConfirmation, hideConfirmation } from 'app/common/actions/confirmation';

import { type OrderItem } from '../../OrderData';
import { useShopCartContext } from '../../CartInit';


const copyItemsToCart = async (
  dispatch: Function,
  items: Array<OrderItem>,
  index: number = 0,
  prevId: number = 0,
  countTypes: number = 0, // количество наименований товаров успешно добавленных из заказа
  countItems: number = 0, // общее количество товаров успешно добавленных из заказа
) => {
  const { variant_id: itemId, quantity } = items[index];
  const res = await dispatch(add2cart(itemId, quantity));
  if (res) {
    const newCountTypes = itemId !== prevId ? countTypes + 1 : countTypes;
    const newCountItems = countItems + quantity;
    if (index + 1 < items.length) {
      return copyItemsToCart(dispatch, items, index + 1, itemId, newCountTypes, newCountItems);
    }
    return [newCountTypes, newCountItems];
  }
  return [countTypes, countItems];
};


type Props = {
  dispatch: Function,
  orderItems: Array<OrderItem>,
  onRedirectToCart?: () => void,
}

function useRepeatOrder({
  dispatch,
  orderItems,
  onRedirectToCart,
}: Props) {
  const [repeating, setRepeating] = useState(false);

  const handleRedirectToCart = useCallback((e?: SyntheticEvent<HTMLElement>) => {
    if (e) {
      e.preventDefault();
      dispatch(hideConfirmation());
      if (onRedirectToCart) {
        onRedirectToCart();
      }
    }
  }, [dispatch, onRedirectToCart]);

  const handleCancel = useCallback((e?: SyntheticEvent<HTMLElement>) => {
    if (e) {
      e.preventDefault();
      dispatch(hideConfirmation());
    }
  }, [dispatch]);


  const [, shopCartActions] = useShopCartContext();

  const handleRepeatOrder = useCallback(async () => {
    await shopCartActions.newCart();

    setRepeating(true);
    const [countTypes, countItems] = await copyItemsToCart(dispatch, orderItems);
    setRepeating(false);

    const message = (countTypes
      ? `Добавлено ${countTypes} ${
        getNumEnding(countTypes, ['наименование', 'наименования', 'наименований'])
      }, всего ${countItems} ${
        getNumEnding(countItems, ['товар', 'товара', 'товаров'])
      }. Перейти в корзину?`
      : 'Не удалось добавить ни одного товара. Перейти в корзину?');

    dispatch(showConfirmation({
      text: message,
      buttons: [{
        value: 'Перейти',
        onClick: handleRedirectToCart,
        key: 'remove',
      }, {
        value: 'Остаться',
        outline: true,
        onClick: handleCancel,
        key: 'cancel',
      }],
    }));
  }, [dispatch, orderItems, handleRedirectToCart, handleCancel, shopCartActions]);

  return [repeating, handleRepeatOrder];
}

export default useRepeatOrder;
